import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

/** El `title` de cada ruta es una clave i18n (`PAGE_TITLES.*`): se traduce al navegar y se
 *  vuelve a traducir cuando cambia el idioma, para que la pestaña no quede en el idioma anterior.
 *  Un título que no sea clave (o sin traducción) se deja tal cual. */
@Injectable({ providedIn: 'root' })
export class TranslatedTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly translate = inject(TranslateService);
  private currentKey: string | undefined;

  constructor() {
    super();
    this.translate.onLangChange.subscribe(() => this.apply());
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.currentKey = this.buildTitle(snapshot);
    this.apply();
  }

  private apply(): void {
    if (this.currentKey === undefined) return;

    const translated = this.translate.instant(this.currentKey);
    this.title.setTitle(typeof translated === 'string' ? translated : this.currentKey);
  }
}
